import * as React from 'react'

import OutOfCodes from '../images/website-out-of-poaps.png'

const WebsiteClaimOutOfCodes: React.FC = () => {
  return (
    <div className="website-out-of-poaps-container">
      <h3>Oh no! This website ran out of POAPs</h3>
      <img src={OutOfCodes} alt="out of codes" />
    </div>
  )
}

export default WebsiteClaimOutOfCodes
